import { render, staticRenderFns } from "./development_cultivation.vue?vue&type=template&id=6d15baf8&scoped=true&"
import script from "./development_cultivation.vue?vue&type=script&lang=js&"
export * from "./development_cultivation.vue?vue&type=script&lang=js&"
import style0 from "./development_cultivation.vue?vue&type=style&index=0&id=6d15baf8&prod&scoped=true&lang=css&"
import style1 from "./development_cultivation.vue?vue&type=style&index=1&id=6d15baf8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d15baf8",
  null
  
)

export default component.exports